// 19.1.2.14 Object.keys(O)
var toObject = require('./$.to-object');

require('./$.object-sap')('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/es6.object.keys.js
// module id = 815
// module chunks = 259